import Box from '@mui/material/Box'
import { IconButton, LinearProgress, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useContext, useMemo } from 'react'
import { noop } from 'lodash'
import { OnboardingContext } from '../../context/onboarding/OnboardingContext'

export interface SectionProps {
	name: string
	label: string
	segments: any[]
	index: number
	active?: boolean
	last?: boolean
	onClick?: any
	sx?: any
}

export default function Section({
	// segments,
	name,
	label,
	// index,
	active = false,
	last = false,
	onClick = noop,
	sx = {}
}: SectionProps) {
	const { useOnboardingState } = useContext(OnboardingContext)
	const { completedSections = [] }: any = useOnboardingState()

	const percentage = useMemo(() => {
		if (completedSections.includes(name)) {
			return 100
		}
		return 0
	}, [completedSections])

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	return (
		<Box sx={{ ...styles.root, ...sx.root }}>
			<Box sx={styles.container}>
				<Box sx={styles.content}>
					<Typography
						variant="h6"
						// color={active ? theme.palette.primary.main : 'inherit'}
						color={
							active
								? theme.palette.primary.main
								: isMobile
									? '#ccc'
									: theme.palette.primary.contrastText
						}
						sx={{
							whiteSpace: {
								xs: 'nowrap'
								// md: 'nowrap'
							},
							fontSize: {
								xs: '0.8rem',
								md: 'inherit'
							}
						}}
					>
						{label}
					</Typography>
				</Box>
				<IconButton
					color="primary"
					sx={{
						...styles.button,
						borderColor: theme.palette.primary.main,
						'&:hover': {
							backgroundColor: theme.palette.primary.contrastText
						}
					}}
					onClick={onClick}
				/>
			</Box>
			{!last && (
				<Box sx={styles.progressContainer}>
					<LinearProgress variant="determinate" value={percentage} sx={styles.progress} />
				</Box>
			)}
		</Box>
	)
}

const styles = {
	root: {
		display: 'flex',
		flex: 1,
		position: 'relative'
	},
	container: {
		display: 'flex',
		position: 'relative'
	},
	content: {
		position: 'absolute',
		top: '-100%',
		left: '50%',
		transform: 'translate(-50%, -100%)'
	},
	progressContainer: {
		display: 'flex',
		flex: 1,
		alignItems: 'center'
	},
	progress: {
		// position: 'absolute',
		width: '100%',
		height: 2
		// top: '50%',
		// transform: 'translateY(-50%)'
	},
	button: {
		p: 0,
		borderWidth: 2,
		borderStyle: 'solid',
		color: {
			xs: '#000',
			md: '#fff'
		},
		fontSize: '1rem',
		// borderRadius: '50%',
		height: 10,
		width: 10
	}
}
